var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificateRibbonFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 19.2451L12.0016 13.2441C10.6318 14.3428 8.89263 15 7 15C5.10843 15 3.37019 14.3435 2.00069 13.2459L2.00252 19.2451C2.00252 19.8529 2.68747 20.2082 3.18436 19.8583L7.00076 17.1706L10.8192 19.8584C11.3161 20.2082 12.0009 19.8528 12.0009 19.2451ZM14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7ZM7.22884 3.64234L8.14136 5.495L10.1853 5.79036C10.3946 5.8206 10.4783 6.07783 10.3268 6.22543L8.84848 7.66589L9.19748 9.7013C9.23322 9.90973 9.01436 10.0686 8.82726 9.97004L7.00006 9.00758L5.17285 9.97004C4.98566 10.0686 4.76674 9.90958 4.80266 9.70109L5.15338 7.66589L3.67339 6.22553C3.52177 6.07798 3.60539 5.82061 3.81478 5.79036L5.85875 5.495L6.77127 3.64234C6.86475 3.45255 7.13536 3.45255 7.22884 3.64234Z",
    fill: "#FF6E40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateRibbonFull);
export default __webpack_public_path__ + "static/media/certificate-ribbon-full.53531972916089012900d867d2b6490b.svg";
export { ForwardRef as ReactComponent };